import { getRoutesFormData, getRoutesKey } from "~/helpers/search"
import useSearchRelated from "./useSearchRelated"

export default function useSearchBarometer(routes = [], items = [], options = {}) {
    const routesKey = getRoutesKey(routes)

    const { data: related, isSuccess: isRelatedSuccess, refetch: fetchRelated } = useSearchRelated(routes, options)
    const barometer = related?.barometer || { items: [] }

    const { data: aircraftBarometer, isSuccess: isBarometerSuccess, refetch: fetchBarometer } = ReactQuery.useQuery({
        queryKey: ['search', 'aircraft-barometer', routesKey],
        queryFn: ({ signal }) => {
            const aircrafts = items
                .map(item => item.aircraft.id)
                .reduce((a, c) => {
                    if (!a.includes(c)) {
                        a.push(c)
                    }

                    return a
                }, [])

            if (aircrafts.length === 0)
                return []

            return searchAction.fetchAircraftsBarometer({
                routes: getRoutesFormData(routes),
                aircrafts: aircrafts,
                signal
            })
        },
        staleTime: Infinity,
        enabled: 'enabled' in options ? options.enabled : true,
    })

    function refetch() {
        fetchRelated()
        fetchBarometer()
    }

    const openBarometerModal = React.useCallback((aircraft_id = null) => {

        const routesTransformed = []
        getRoutesFormData(routes).map((r, index) => {
            if (index === 0 || !(r.from.id === routes[index - 1].to.id && r.from.type === routes[index - 1].to.type)) {
                routesTransformed.push({
                    icao: r.from.icao,
                    title: r.from.title
                })
            }
            routesTransformed.push({
                icao: r.to.icao,
                title: r.to.title
            })
        })

        const aircraft = aircraftBarometer.find(e => e.aircraft.id == aircraft_id)

        $.fancybox.open({
            src: '#reactBarometerModal',
            props: {
                tab: aircraft ? 'aircraft' : 'classes',
            },
            afterShow: () => {
                raiseEvent('react.openBarometer', { routes: routesTransformed, classes: barometer, aircraft: aircraft });
            },
            afterClose: () => {
                raiseEvent('react.openBarometer', { routes: [], classes: [], aircraft: null });
            }
        })
    }, [routes, barometer, aircraftBarometer])

    const checkItemPriceBelowAnnual = React.useCallback((item) => {
        const averagePrice = aircraftBarometer.find(e => e.aircraft.id == item.aircraft.id)?.average_price || null
        if (!averagePrice || !item.prices.price || isNaN(averagePrice) || isNaN(item.prices.price)) return false;
        return item.prices.price < averagePrice
    }, [aircraftBarometer])

    return {
        barometer,
        aircraftBarometer,

        isLoaded: isRelatedSuccess && isBarometerSuccess,

        refetch,
        openBarometerModal,

        checkItemPriceBelowAnnual,
    }
}
